import Slider from "../Index/Slider.js"
import Pager from "../Index/Pager.js"
// import Video from "../Index/Video.js"
import Bottom from "../Index/Bottom.js"

let Main = () =>{
    return (        
        <div>        
            <Slider />
            <Pager />
            {/*<Video />*/}
            <Bottom />
        </div>
    )
}

export default Main;